document.addEventListener("BSS:openInputSearch", () => {
  const inputSearch =  document.querySelector(`[action="/search"] input#search-in-modal`);

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});

document.addEventListener("BSS:changeVariant", () => {
  setTimeout(() => {
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 1500)
});

(() => {
  setTimeout(() => {
    handleQuickView();
  }, 1000)
})();

function handleQuickView(){
  const targetNode = document.getElementById('QuickView');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          const currentDisplay = targetNode.style.display;
          if(!currentDisplay) {
              setTimeout(() => {
                  document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
              },2000)
          }
        }
      }
    });
  
    const config = {
      attributes: true,
      attributeFilter: ['style'], 
    };
  
    observer.observe(targetNode, config);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const cartIcon = document.querySelector(`#cart-icon`);
  if (!cartIcon) return;

  let debounceTimer;
  cartIcon.addEventListener("click", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 500);
  });
});